module.exports = __webpack_public_path__ + "img/cspace-xpage.5edc1e98.svg";